import { Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap'
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { SearchTableButton } from '../../../../utils/Constant';
import api from '../../../../utils/api';
import { BookingHistoryTableDataColumnType } from '../../../../Types/Application/Ecommerce/Ecommerce';
import BookingHistoryFilterHeader from '../../../../Componant/Application/Ecommerce/ProductList/BookingHistoryFilterHeader';
import { BookingHistoryTableProductName, BookingHistoryTableStatus } from '../../../../Data/Application/Ecommerce/BookingHistory';

const BookingCancelledContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [bookingHistoryTableDatas, setBookingHistoryTableDatas] = useState([]);

  // Pagination-related states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchTickets = async (page: number, size: number) => {
    const role = JSON.parse(localStorage.getItem("user")!).role;
    const staffId = JSON.parse(localStorage.getItem("user")!).staffId;
    try {
      setLoading(true);

      let response;
      if (role === "Admin") {
        response = await api.get(
          `/api/TicketBooking/GetAllTicketCancelledPagination?pageNumber=${page}&pageSize=${size}`
        );

        if (response.status === 200) {
          setBookingHistoryTableDatas(
            response.data.items.map((item: any): BookingHistoryTableDataColumnType => ({
              ticketBookingId: item.ticketBookingId,
              ticketNumber: item.ticketNumber,
              ticketCountNo: item?.ticketCountNo ?? 'SWP-XX',
              emailId: item.emailId,
              ticketUniqueId: item.ticketUniqueId,
              bookingDate: new Date(item.bookingDate).toISOString().split('T')[0],
              customerName: item.customerName,
              customerMobileNumber: item.customerMobileNumber,
              address: item.address,
              numberOdAdults: item.numberOdAdults,
              numberOfChildren: item.numberOfChildren,
              createdDate: new Date(item.createdDate).toISOString().split('T')[0],
              applicationUserId: item.applicationUserId,
              staffName: item.staffName,
              staffId: item.staffId,
              counterStatus: item.counterStatus,
              payAmount: item.payAmount,
              razorpayPaymentId: item.razorpayPaymentId,
              ticketStatus: item.ticketStatus,
              portal: item.portal,
              onlineAmount: item?.onlineAmount,
              cashAmount: item?.cashAmount,
              discountPer: item?.discountPer,
              discountAmt: item?.discountAmt,
            }))
          );
          setTotalRows(response.data.totalCount);
        }
      } else {
        // Staff users - no pagination available
        response = await api.get(
          `/api/TicketBooking/GetAllCancelBookingHistoryByStaffId?staffId=${staffId}`
        );

        if (response.status === 200) {
          setBookingHistoryTableDatas(
            response.data.map((item: any): BookingHistoryTableDataColumnType => ({
              ticketBookingId: item.ticketBookingId,
              ticketNumber: item.ticketNumber,
              ticketCountNo: item?.ticketCountNo ?? 'SWP-XX',
              emailId: item.emailId,
              ticketUniqueId: item.ticketUniqueId,
              bookingDate: new Date(item.bookingDate).toISOString().split('T')[0],
              customerName: item.customerName,
              customerMobileNumber: item.customerMobileNumber,
              address: item.address,
              numberOdAdults: item.numberOdAdults,
              numberOfChildren: item.numberOfChildren,
              createdDate: new Date(item.createdDate).toISOString().split('T')[0],
              applicationUserId: item.applicationUserId,
              staffName: item.staffName,
              staffId: item.staffId,
              counterStatus: item.counterStatus,
              payAmount: item.payAmount,
              razorpayPaymentId: item.razorpayPaymentId,
              ticketStatus: item.ticketStatus,
              portal: item.portal,
              onlineAmount: item?.onlineAmount,
              cashAmount: item?.cashAmount,
              discountPer: item?.discountPer,
              discountAmt: item?.discountAmt,

            }))
          );
          setTotalRows(response.data.length);
        }
      }
    } catch (error) {
      console.error("Failed to fetch booking history:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets(currentPage, pageSize);
  }, [currentPage, pageSize]);

  //   const handleDelete = async (id: number) => {
  //     // Your delete logic here (API call, state update, etc.)
  //     // console.log("Deleting ID:", id);
  //     try {
  //       await api.put(`/api/TicketBooking/TicketBookingCancel?ticketBookingId=${id}`);
  //       Swal.fire('Cancelled!', ' Ticket Booking has been cancelled successful.', 'success');

  //       // Optional: refresh the list
  //       setBookingHistoryTableDatas((prev) => prev.filter((item: { adultPlanId: any; }) => item.adultPlanId !== id));
  //     } catch (error) {
  //       Swal.fire('Error!', 'Failed to cancelled the ticket booking.', 'error');
  //       console.error("Cancelled error:", error);
  //     }
  //   };

  const bookingHistoryTableDataColumn: TableColumn<BookingHistoryTableDataColumnType>[] = [
    {
      name: "Ticket ID",
      cell: (row) => <BookingHistoryTableProductName title={row.ticketCountNo} />,
      grow: 2,
    },
    {
      name: "Ticket Number",
      selector: (row) => `${row.ticketUniqueId}`,
      grow: 2,
    },
    {
      name: "Name",
      selector: (row) => `${row.customerName}`,
    },
    {
      name: "Mobile No.",
      cell: (row) => <BookingHistoryTableStatus title={row.customerMobileNumber} />,
    },
    {
      name: "No. Of Adults",
      cell: (row) => <BookingHistoryTableStatus title={row.numberOdAdults} />,
    },
    {
      name: "No. Of Child",
      cell: (row) => <BookingHistoryTableStatus title={row.numberOfChildren} />,
    },
    {
      name: "Pay Amount",
      cell: (row) => <BookingHistoryTableStatus title={row.payAmount} />,
    },
    {
      name: "Online Amount",
      cell: (row) => (
        <span style={{ fontWeight: 600, color: "#1a5c2a", width: "220px", display: "inline-block" }}>
          ₹{row.onlineAmount || 0}
        </span>
      ),
    },
    {
      name: "Cash Amount",
      cell: (row) => (
        <span style={{ fontWeight: 600, color: "#1a5c2a" }}>
          ₹{row.cashAmount || 0}
        </span>
      ),
    },
    {
      name: "Booking Date",
      cell: (row) => <BookingHistoryTableStatus title={row.bookingDate} />,
    },
    {
      name: "Address",
      cell: (row) => (<div style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '300px' }}>{row.address}  </div>),
      wrap: true,
    },
    {
      name: "Counter",
      cell: (row) => <BookingHistoryTableStatus title={row.counterStatus} />,
    },
    {
      name: "Created Date",
      cell: (row) => <BookingHistoryTableStatus title={row.createdDate} />,
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

  const filteredItems = bookingHistoryTableDatas.filter((item: any) => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search)
    );
  });

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <BookingHistoryFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    columns={bookingHistoryTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    progressPending={loading}
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default BookingCancelledContainer